import React, { useContext } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import AuthenticationContext from '../../contexts/AuthenticationContext';

// export interface IRedirectRouteProps {
//   location: {
//     pathname: string;
//   };
// }

const IdentityAuth: React.FC = () => {
  const location = useLocation();
  const authStore = useContext(AuthenticationContext);

  const urlSearchParams = new URLSearchParams(location.search);


  if (authStore.loggedIn) {
    return <Redirect to={urlSearchParams.get('to') || '/'} />;
  } else {
    return <p>... redirecting</p>;
  }
};

export default IdentityAuth;
